import { render, staticRenderFns } from "./SchedulePage.vue?vue&type=template&id=728965b6"
import script from "./SchedulePage.vue?vue&type=script&lang=js"
export * from "./SchedulePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports